module.exports = __webpack_public_path__ + "static/media/check.25df15af.svg";